import { combineReducers } from 'redux';
import webConfiguretion from './webConfiguretion';

export default combineReducers({
    webConfiguretion
});
